/**
 * @class
 * @classdesc Class for handling HCS toolbar.
 * 
 * @param {object} paramObj - Parameters
 * @param {object} paramObj.hcs - Instance to HCS.
 */
export default class HcsToolbar
{
    constructor(paramObj) {
        let self = this;

        this.hcs = paramObj.hcs;

        this.toolbarButtonClickedListeners = [];

        this.hcs.api.instance(".hcs-toolbar hcs-toolbar-button").forEach((button) => {
            let masterButton = button.querySelector(":scope > button");

            let subItemContainer = button.querySelector(".items");

            if(subItemContainer !== null) {
                masterButton.addEventListener("click", () => { self.toggleSubItems.call(self, button); });
            }

            button.querySelectorAll(".items button").forEach((subButton) => {
                subButton.addEventListener("click", () => { self.toggleSubItems.call(self, button, false); });
            });
        });

        this.hcs.api.instance(".hcs-toolbar button").forEach((button) => {
            button.addEventListener("click", (event) => {
                self.toolbarButtonClickedListeners.forEach(listener => {
                    listener.call(self, event);
                });
            });
        });

        // Show toolbar after initialization.
        // The reason is to hide this empty strange looking shadow line until toolbar is completed.
        this.show();

        window.addEventListener(
            "message",
            (event) => {
                // close open toolbar when user clicks inside ccAO area
                switch(event.data.messageType) {
                    case "ccAO.click":
                    case "ccAO.noIntersectClick":
                        self.close();
                        break;
                }
            },
            false
        );

        // Close open toolbar when user clicks inside configurator
        this.hcs.api.instance(".hcs-config-area, .hcs-cart-container").forEach(i => {
            i.addEventListener("click", () => {
                self.close();
            });
        });
    }

    toolbarButtonClicked(listener) {
        this.toolbarButtonClickedListeners.push(listener);
    }

    /**
     * Make toolbar visible
     */
    show() {
        this.hcs.api.instance(".hcs-toolbar").classList.remove("hcs-hidden");
    }

    /**
     * Hide toolbar.
     * Toolbar will then completely invisible.
     */
    hide() {
        this.hcs.api.instance(".hcs-toolbar").classList.add("hcs-hidden");
    }

    /**
     * Close possible open toolbar subgroup
     */
    close() {
        let openGroup = this.instance("hcs-toolbar-button.hcs-open");

        // close open button group when user clicks inside ccAO area
        if(openGroup && typeof (openGroup.classList) !== "undefined") {
            openGroup.classList.remove("hcs-open");
        }
    }

    /**
     * Handle click event for buttons which contains child buttons.
     * @param {object} button - Reference to main button.
     * @param {bool} [forceClose=false] - When "true" menu will not be toggled but
     * only closed (when open).
     */
    toggleSubItems(button, forceClose = false) {
        if(button.classList.contains("hcs-open") || forceClose) {
            button.classList.remove("hcs-open");
        } else {
            let openBox = button.parentNode.querySelector(".hcs-open");

            // Close possible open box because we only allow one submenu open
            if(openBox !== null) {
                openBox.classList.remove("hcs-open");
            }

            button.classList.add("hcs-open");
        }
    }

    /**
     * Select elements inside toolbar.
     * @param { string } [selector] - CSS selector to select elements. Leave empty to get the main container.
     * @returns { Object | Array } DOM element(s) for given selector.
     * Returns a single DOM element when selector matches excatly one item, otherwise an array of DOM elements.
     */
    instance(selector) {
        return this.hcs.api.instance(selector, this.hcs.api.instance(".hcs-toolbar"));
    }
}